import {Component, Inject, Input, PLATFORM_ID} from '@angular/core';
import {Product} from '../../interface/product';
import {ProductInFinishProduct} from '../../interface/product-in-finish-product';
import {Router} from "@angular/router";
import {isPlatformBrowser} from '@angular/common';

@Component({
	selector: 'fb-product-accordion',
	templateUrl: './product-accordion.component.html',
	styleUrls: ['./product-accordion.component.scss']
})
export class ProductAccordionComponent {

	@Input() dataAccordion: Product = {} as Product;
	@Input() dataGsm: ProductInFinishProduct = {} as ProductInFinishProduct;
	public deltaIndex = 0;
	public isFabric: boolean = false;
	public isBrowser: boolean = false;

	constructor(
		private _router: Router,
		@Inject(PLATFORM_ID) private _platformId: Object
	) {
		this.isBrowser = isPlatformBrowser(this._platformId);
	}
	public accTriger(i: number) {
		this.deltaIndex = i;
	};

	public ngOnInit(): void {
		// debugger
		// console.log(this.dataAccordion.productCare);

		if (this.isBrowser) {
			let url = window.location.href;
			this.isFabric = url.includes('fabric-product');
		}

	}

	public navigate(
		isFabric: boolean,
		paramKey: string,
		paramValue: string
	): void {
		if(paramValue !== 'Tie - Dye') {
			paramKey = paramKey.toLowerCase().replace(/ /g, '-');
			paramValue = paramValue.toLowerCase().replace(/ /g, '-');
		}
		else {
			paramKey = paramKey.toLowerCase().replace(/ /g, '-');
			paramValue = paramValue.toLowerCase().replace(/ /g, '');
		}
		if(isFabric) {
			this._router.navigate(['products/fabric',],
				{ queryParams: { [paramKey]: paramValue}}).then((): void => {
			});
		}
		else{
			this._router.navigate(['products/finished',],
				{ queryParams: { [paramKey]: paramValue}}).then((): void => {
			});
		}

	}
}
